import React from 'react'

const RedirectToSignUp = React.lazy(() => import('./components/Common/RedirectToSignUp'))

// SignUp
const SignUpContainer = React.lazy(() => import('./containers/SignUpContainer'))
//.end#SignUp

// VerifyNumber
const VerifyNumberContainer = React.lazy(() => import('./containers/VerifyNumberContainer'))
//.end#VerifyNumber

// SuccessfulPage
const SuccessfulPageContainer = React.lazy(() => import('./containers/SuccessfulPageContainer'))
//.end#SuccessfulPage

// ConfirmationPage
const ConfirmationPageContainer = React.lazy(() => import('./containers/ConfirmationPageContainer'))
//.end#ConfirmationPage

// SubmitSuccessful
const SubmitSuccessfulContainer = React.lazy(() => import('./containers/SubmitSuccessfulContainer'))
//.end#SubmitSuccessful

// CompleteApplication
const CompleteApplicationContainer = React.lazy(() => import('./containers/CompleteApplicationContainer'))
//.end#CompleteApplication

// JotForm
const JotForm = React.lazy(() => import('./containers/JotForm'))
//.end#JotForm

// FinishApplication
const FinishApplicationContainer = React.lazy(() => import('./containers/FinishApplicationContainer'))
//.end#FinishApplication

// Agreement
const AgreementContainer = React.lazy(() => import('./containers/AgreementContainer'))
//.end#Agreement

// SignIn
const SignInContainer = React.lazy(() => import('./containers/SignInContainer'))
//.end#SignIn

// ETraining
const ETrainingContainer = React.lazy(() => import('./containers/ETrainingContainer'))
//.end#ETraining

// ExamDetail
const ExamDetailContainer = React.lazy(() => import('./containers/ExamDetailContainer'))
//.end#ExamDetail

// Agreement
const SelectAddressContainer = React.lazy(() => import('./containers/SelectAddressContainer'))
//.end#Agreement

const ETrainingSignInContainer = React.lazy(() => import('./containers/ETrainingSignInContainer'))

// PrivacyPolicy
const PrivacyPolicyContainer = React.lazy(() => import('./containers/PrivacyPolicyContainer'))
// .end#PrivacyPolicy

// TermsDriver
const TermsDriverContainer = React.lazy(() => import('./containers/TermsDriverContainer'))
// .end#TermsDriver

// IframeContainer
const IframeContainer = React.lazy(() => import('./containers/IframeContainer'))
// .end#IframeContainer

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const verifyCountry = JSON.parse(window.localStorage.getItem('dlvr_verifyCountry'))
const isTransportify = verifyCountry.isTransportify === true
const routes = [
  // RootPage
  {
    path: `${isTransportify ? '/' : `/${verifyCountry.country_code}`}`, exact: true, name: 'Select Your Area', component: RedirectToSignUp
  },
  //.end#RootPage

  // redirect login to sign_up
  {
    path: `${isTransportify ? '/login' : `/${verifyCountry.country_code}/login`}`, exact: true, name: 'Login', component: RedirectToSignUp
  },
  //.end#redirect

  // SignUp
  { path: `${isTransportify ? '/sign_up' : `/${verifyCountry.country_code}/sign_up`}`, exact: true, name: 'Sign Up', component: SignUpContainer },
  //.end#SignUp

  // SignUp
  { path: '/sign_up', exact: true, name: 'Sign Up', component: SignUpContainer },
  //.end#SignUp

  // VerifyNumber
  { path: `${isTransportify ? '/verify_number' : `/${verifyCountry.country_code}/verify_number`}`, exact: true, name: 'Verify Number', component: VerifyNumberContainer },
  //.end#VerifyNumber

  // SuccessfulPage
  { path: `${isTransportify ? '/successful_page' : `/${verifyCountry.country_code}/successful_page`}`, exact: true, name: 'Successful Page', component: SuccessfulPageContainer },
  //.end#SuccessfulPage

  // ConfirmationPage
  { path: `${isTransportify ? '/confirmation_page' : `/${verifyCountry.country_code}/confirmation_page`}`, exact: true, name: 'Confirmation Page', component: ConfirmationPageContainer },
  //.end#ConfirmationPage

  // SubmitSuccess
  { path: `${isTransportify ? '/submit_successful' : `/${verifyCountry.country_code}/submit_successful`}`, exact: true, name: 'Submit Successful', component: SubmitSuccessfulContainer },
  //.end#SubmitSuccess

  // CompleteApplication
  { path: `${isTransportify ? '/complete_application' : `/${verifyCountry.country_code}/complete_application`}`, exact: true, name: 'Complete Application', component: CompleteApplicationContainer },
  //.end#CompleteApplication

  // show JotForm
  { path: `${isTransportify ? '/jotform_id' : `/${verifyCountry.country_code}/jotform_id`}`, exact: true, name: 'JotForm', component: JotForm },
  //.end#show JotForm
  // FinishApplication
  { path: `${isTransportify ? '/finish_application' : `/${verifyCountry.country_code}/finish_application`}`, exact: true, name: 'Finish Application', component: FinishApplicationContainer },
  //.end#FinishApplication

  // SignIn
  { path: `${isTransportify ? '/sign_in' : `/${verifyCountry.country_code}/sign_in`}`, exact: true, name: 'Sign In', component: SignInContainer },
  //.end#SignIn

  // ETraining
  { path: `${isTransportify ? '/e_training/:driverId' : `/${verifyCountry.country_code}/e_training/:driverId`}`, exact: true, name: 'E-Training', component: ETrainingContainer },
  //.end#ETraining

  // Agreement
  {
    path: isTransportify ? '/agreement/:documentName' : `/${verifyCountry.country_code}/agreement/:documentName`,
    name: 'Agreement',
    component: AgreementContainer
  },
  //.end#Agreement

  // ExamDetail
  { path: `${isTransportify ? '/e_training/:driverId/exams/:examId' : `/${verifyCountry.country_code}/e_training/:driverId/exams/:examId`}`, exact: true, name: 'Exam', component: ExamDetailContainer },
  //.end#ExamDetail

  // SelectAddress
  {
    // exact: true,
    path: isTransportify ? '/select_address' : `/${verifyCountry.country_code}/select_address`,
    name: 'Select Address',
    component: SelectAddressContainer
  },
  //.end#SelectAddress

  {
    path: `${isTransportify ? '/etraining_signin/:driverId' : `/${verifyCountry.country_code}/etraining_signin/:driverId`}`,
    exact: true,
    name: 'ETraining SignIn',
    component: ETrainingSignInContainer
  },
  
  // PrivacyPolicy
  { path: `${isTransportify ? '/privacy-policy' : `/${verifyCountry.country_code}/privacy-policy`}`, exact: true, name: 'Privacy Policy', component: PrivacyPolicyContainer },
  //.end#PrivacyPolicy

  // TermsDriver
  { path: `${isTransportify ? '/terms-and-conditions-for-driver' : `/${verifyCountry.country_code}/terms-and-conditions-for-driver`}`, exact: true, name: 'Terms And Condition For Driver', component: TermsDriverContainer },
  //.end#TermsDriver

  // IframeContainer
  { path: `${isTransportify ? '/iframe' : `/${verifyCountry.country_code}/iframe`}`, exact: true, name: 'FAQ', component: IframeContainer },
  //.end#IframeContainer
]

export default routes
